export const container = `
  absolute top-0 left-0 w-full h-full bg-base-white
  p-4 flex flex-col grow overflow-y-scroll

  translate-x-full data-[is-open=true]:translate-x-0
  transition-transform duration-15 ease-in-out
`;
